@if (loading) {
  <div class="page-loading">
    <p-progressSpinner ariaLabel="loading" />
  </div>
}

@if (!loading && affair) {
  <div class="eros-schedule-page">
    <!-- ── Header compact ── -->
    <header class="page-header">
      <span class="hero-badge">
        <i class="pi pi-bolt"></i>
        Programmation EROS
      </span>
      <h1 class="hero-title">
        {{ affair.mlRef }} — {{ affair.finalCustomerLastname }}
        @if (affair.finalCustomerLastnameSecondary) {
          / {{ affair.finalCustomerLastnameSecondary }}
        }
      </h1>
      <div class="hero-meta">
        @if (affair.workSiteLocality) {
          <span class="hero-meta-item">
            <i class="pi pi-map-marker"></i>
            {{ affair.workSitePostalCode }} {{ affair.workSiteLocality }}
          </span>
        }
        @if (schedulableProducts.length > 0) {
          <span class="hero-meta-item">
            <i class="pi pi-box"></i>
            {{ schedulableProducts.length }} produit{{
              schedulableProducts.length > 1 ? 's' : ''
            }}
          </span>
        }
        @if (hasWishedWindow) {
          <span
            class="wished-window-badge"
            [class.is-violated]="isOutsideWishedWindow"
            title="Fenêtre de planification souhaitée (transmise par EROS)"
          >
            <i class="pi pi-calendar-clock"></i>
            Souhaité {{ wishedWindowLabel }}
          </span>
        }
      </div>
    </header>

    <!-- Alerte : l'horaire retenu sort de la fenêtre souhaitée -->
    @if (isOutsideWishedWindow) {
      <div class="wished-window-warning">
        <i class="pi pi-exclamation-triangle"></i>
        La date retenue est en dehors de la fenêtre de planification souhaitée
        ({{ wishedWindowLabel }}).
      </div>
    }

    <!-- ── Erreur ── -->
    @if (interventionError) {
      <div class="error-banner">
        <i class="pi pi-exclamation-circle"></i>
        {{ interventionError }}
      </div>
    }

    <!-- ── 1. Bandeau des propositions ── -->
    <div class="proposals-strip">
      <span class="strip-label">
        <span class="section-step">1</span>
        Créneau
      </span>
      @if (proposals.length === 0) {
        <span class="empty-state">
          <i class="pi pi-info-circle"></i>
          Aucune proposition transmise pour cette affaire.
        </span>
      } @else {
        <div class="proposals-row">
          @for (proposal of proposals; track $index) {
            <button
              type="button"
              class="proposal-chip"
              [class.is-selected]="selectedProposalIndex === $index"
              (click)="selectProposal($index)"
            >
              <i
                class="pi"
                [class.pi-circle]="selectedProposalIndex !== $index"
                [class.pi-check-circle]="selectedProposalIndex === $index"
              ></i>
              <span class="chip-date">{{ formatProposalDate(proposal) }}</span>
              @if (formatProposalTime(proposal)) {
                <span class="chip-time">{{ formatProposalTime(proposal) }}</span>
              }
              @if (proposal.technicianName) {
                <span class="chip-tech">
                  <span class="tech-avatar">
                    {{ technicianInitials(proposal.technicianName) }}
                  </span>
                  {{ proposal.technicianName }}
                </span>
              }
            </button>
          }
        </div>
      }
    </div>

    <!-- ── 2 & 3. Panneaux côte à côte ── -->
    <div class="panels">
      @if (canShowForms) {
        <section class="panel panel-schedule">
          <div class="panel-header">
            <span class="section-step">2</span>
            <span class="panel-title">Horaire &amp; plage horaire</span>
          </div>
          <div class="panel-body">
            <app-affair-schedule-intervention-schedule
              [droppedDetails]="droppedDetails"
              [selectedTechnicians]="selectedTechnicians"
              [scheduleForm]="scheduleForm"
              [usersList]="usersForSelect"
              (formScheduleChanged)="onScheduleChanged($event)"
              (techniciansIncompatibleErpChanged)="
                techniciansIncompatible = $event
              "
            ></app-affair-schedule-intervention-schedule>
          </div>
        </section>

        <section class="panel panel-create">
          <div class="panel-header">
            <span class="section-step">3</span>
            <span class="panel-title">Informations de l'intervention</span>
          </div>
          <div class="panel-body">
            <app-affair-schedule-intervention-create
              [affair]="affair"
              [selectedTechnicians]="selectedTechnicians"
              [droppedDetails]="droppedDetails"
              [scheduleData]="scheduleData"
              [interventionForm]="interventionForm"
              (formError)="onInterventionFormError($event)"
              (formStateChanged)="onInterventionFormStateChanged($event)"
            ></app-affair-schedule-intervention-create>
          </div>
        </section>
      } @else if (proposals.length > 0) {
        <div class="panels-placeholder">
          <i class="pi pi-arrow-up"></i>
          Sélectionnez une proposition pour ajuster l'horaire et compléter
          l'intervention.
        </div>
      }
    </div>

    <!-- ── Barre d'action ── -->
    <footer class="action-bar">
      @if (selectedProposal) {
        <span class="action-summary">
          <i class="pi pi-calendar"></i>
          {{ formatProposalDate(selectedProposal) }}
          @if (selectedProposal.technicianName) {
            · {{ selectedProposal.technicianName }}
          }
          @if (interventionFormLoading) {
            <span class="generating-hint">
              <i class="pi pi-spin pi-spinner"></i>
              génération en cours…
            </span>
          }
        </span>
      } @else {
        <span class="action-summary muted">Aucune proposition sélectionnée</span>
      }
      <button
        pButton
        type="button"
        (click)="onSubmitIntervention()"
        [loading]="submittingIntervention"
        [disabled]="!canSubmit"
        label="Créer l'intervention sur EROS"
        icon="pi pi-check"
        class="p-button-success"
      ></button>
    </footer>
  </div>
}

@if (!loading && !affair) {
  <div class="page-error">
    <i class="pi pi-exclamation-circle"></i>
    Impossible de charger l'affaire {{ mlRef }}.
  </div>
}
